export const startInitFormData = {
  household: '',
  zipcode: '',
  dma_id: '',
  county_id_fk: '',
  dvr: '',
  'already-have': [],
  streaming: [],
  content: [],
  'content-other': '',
  sports: '',
  partner_id_fk: 0,
  device_included: '',
  answers: [],
  agree_device_contract: null,
  flow: '',
};

export const wizardSteps = [
  { name: 'household', partner_extra: false },
  { name: 'zip', partner_extra: false },
  { name: 'dvr', partner_extra: false },
  { name: 'device-included', partner_extra: false },
  { name: 'already-have', partner_extra: false },
  { name: 'streaming', partner_extra: false },
  { name: 'content', partner_extra: false },
  { name: 'sports', partner_extra: false },
];

export const wizardStepsNewOrder = [
  { name: 'already-have', partner_extra: false },
  { name: 'zip', partner_extra: false },
  { name: 'device-included', partner_extra: false },
];

export default wizardSteps;
